import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useCidco } from "./CidcoLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = useCidco();
  const list = data.executive_body || [];
  return (
    <div data-testid="cid-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="cyan" testidPrefix="cid-eb-page" />
      </PageBody>
    </div>
  );
}
